import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSON} from '../../platform/functional-fetch-wrapper'
import type {CreateColumnOptionRequest, CreateColumnOptionResponse} from './contracts/api'

export async function apiAddOption(body: CreateColumnOptionRequest): Promise<CreateColumnOptionResponse> {
  const apiData = getApiMetadata('memex-column-option-create-api-data')
  const {data} = await fetchJSON<CreateColumnOptionRequest, CreateColumnOptionResponse>(apiData.url, {
    method: 'POST',
    body,
    token: apiData.token,
  })

  return data
}
